import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import finalCtaImg from "@/assets/final-cta-v2.jpg";

const FinalCTASection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={finalCtaImg} alt="" className="w-full h-full object-cover opacity-55" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/65 to-background/35" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center space-y-6">
          <h2 className="font-display text-4xl md:text-5xl text-foreground">
            Start with care designed to stay with you.
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            If you are looking for a more thoughtful, supported path to better health, Elara offers a premium care experience built around personalization, clinical guidance, and continuity.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Link to="/get-started">
              <Button size="lg" className="gap-2 text-base">
                Start Your 2-Minute Assessment <ArrowRight size={18} />
              </Button>
            </Link>
            <a href="#how-it-works">
              <Button variant="outline" size="lg" className="text-base">
                How It Works
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
